<style scoped>

</style>
<template>
  <div>
    <div class="line text-center">
      <!-- <i-input v-model="params.search" @on-enter="doSearch" placeholder="请输入搜索关键字" style="width: 100px"></i-input> -->
      <i-input
        v-model="params.model"
        placeholder="Model"
        style="width: 100px"
      />
      <InputNumber
        v-model="params.model_id"
        :min="0"
        :step="0"
        placeholder="Model Id"
        style="width: 80px"
      />
      <Ajaxbtn
        ref="searchBtn"
        :url="get_logs_path"
        :params="params"
        type="search"
        @before="beforeSearch"
        @done="handleData"
        @fail="handleFail"
      />
    </div>

    <div class="list-container">
      <Table
        ref="table"
        border
        :columns="log_columns"
        :data="logs"
        size="small"
      />
      <Backdrop v-show="loading" />
    </div>

    <div
      v-show="page_info.total"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>
  </div>
</template>
<script route="/dev/commit_log">
  import Util from '../../libs/util';
  export default {
    /* router_info_start */
    router_info: '/dev/commit_log',
    /* router_info_end */
    data() {
      return {
        get_logs_path: Util.api.get_commit_logs,
        loading: false,
        params: {
          per_page: 20,
          page: 1,
          search: '',
          model: '',
          model_id: 0,
          status: 0
        },
        page_info: {
          current: 1,
          total: 0,
          page_size: 20
        },
        logs: [],
        log_columns: [
          {
            title: '用户',
            align: 'center',
            width: 100,
            render: (h, params) => {
              const row = params.row;
              const ret = [];
              if (row.user_id) {
                ret.push(h('div', `${row.user_name}(${row.user_id})`));
              } else {
                if (row.user_name) {
                  ret.push(h('div', row.user_name));
                } else {
                  ret.push(h('div', 'auto'));
                }
              }
              return h('div', ret);
            }
          },
          {
            title: 'IP地址',
            width: 100,
            align: 'center',
            key: 'ip_addr'
          },
          {
            title: '操作来源',
            width: 70,
            align: 'center',
            key: 'op_from'
          },
          {
            title: '操作类型',
            width: 70,
            align: 'center',
            key: 'op_type'
          },
          {
            title: 'Model',
            width: 100,
            align: 'center',
            key: 'op_model'
          },
          {
            title: 'ModelId',
            width: 70,
            align: 'center',
            key: 'op_model_id'
          },
          {
            title: 'content',
            align: 'center',
            tooltip: true,
            key: 'content'
          },
          {
            title: '操作时间',
            align: 'center',
            width: 140,
            key: 'created_at',
            render: (h, params) => {
              const row = params.row;
              return h('span', Util.formatTime(row.created_at));
            }
          }
        ]
      }
    },
    computed: {
      //
    },
    created() {
      //
    },
    mounted() {
      this.doSearch();
    },
    methods: {
      pageChange(new_page) {
        this.params.page = new_page;
        this.loading = true;
        this.$refs.searchBtn.doAjax(true);
      },
      doSearch() {
        this.params.page = 1;
        this.loading = true;
        this.$refs.searchBtn.doAjax();
      },
      beforeSearch() {
        //
      },
      handleData(data) {
        this.loading = false;
        this.logs = data.logs;
        this.page_info.current = data.cur_page;
        this.page_info.page_size = data.per_page;
        this.page_info.total = data.total_count;
      },
      handleFail(e) {
        this.loading = false;
        this.$Modal.error({title: '错误', content: e.message});
      },

    }
  }
</script>
